import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import _map from 'lodash/map';
import _values from 'lodash/values';
import { DASHBOARD_RESOURCES, PAGE_NAMES } from 'constant';
import AuthorizedRoute from 'routes/AuthorizedRoute';
import CtdList from './CtdList';
import { URL as CtdUrl } from '../helper';
import { URL, COMPONENT, CTD_RESOURCES, GET_ACTION } from './ctdHelper';

const CtdDashboardHome: React.FC = () => {
	return (
		<>
			<Switch>
				<AuthorizedRoute
					exact
					entity={DASHBOARD_RESOURCES.finance}
					configPageName={PAGE_NAMES.dashboard}
					path={CtdUrl.ctd}
					component={CtdList}
				/>
				{_map(_values(CTD_RESOURCES), (subEntity) => (
					<AuthorizedRoute
						key={subEntity}
						configPageName={PAGE_NAMES.dashboard}
						entity={DASHBOARD_RESOURCES.finance}
						actions={[GET_ACTION[subEntity]]}
						path={URL[subEntity]}
						component={COMPONENT[subEntity]}
					/>
				))}
				<Redirect to={CtdUrl.ctd} />
			</Switch>
		</>
	);
};

export default CtdDashboardHome;
